import { useCallback } from "react";
import { getIssuesRemoteOverride } from "../utils/remoteOverridesUtils";

const ISSUES_REMOTE_OVERRIDE_KEY = "accIssues";

/**
 * React hook that returns a function to add issues remote override to URLs.
 * This is useful for links that open in a new tab, as the remote overrides won't carry over automatically.
 *
 * @returns A function that takes a URL string and returns the URL with issues remote override added
 */
export function useIssuesRemoteOverrideUrl(): (url: string) => string {
  return useCallback((url: string): string => {
    const issuesRemoteOverride = getIssuesRemoteOverride();

    if (!issuesRemoteOverride) {
      return url;
    }

    try {
      const urlObj = new URL(url);
      urlObj.searchParams.set(ISSUES_REMOTE_OVERRIDE_KEY, issuesRemoteOverride);
      return urlObj.toString();
    } catch (e) {
      console.error(
        "Invalid URL provided to useIssuesRemoteOverrideUrl:",
        url,
        e
      );
      return url;
    }
  }, []);
}
